/**
 * When a failed test's answer arrives, the field it is about scrolls into view (Option C, C2; spec B/C "the field in
 * error is scrolled into view when the strip appears"): Server for an unreachable host, Login for a refused login, the
 * SSH host for an unreachable bastion … A collapsed section around it opens first. Focus never moves — the user may be
 * reading the strip or typing elsewhere. Once per answer: an answer that hides and shows again does not scroll again.
 */
import { useEffect, useRef } from 'react';
import { revealAndScroll } from './formSectionReveal';

export function useErrorFieldInView(answer: object | null, fieldSelector: string | undefined): void {
  const scrolledFor = useRef<object | null>(null);
  useEffect(() => {
    if (!answer || !fieldSelector || scrolledFor.current === answer) return;
    scrolledFor.current = answer;
    revealAndScroll(fieldSelector);
  }, [answer, fieldSelector]);
}
